import { createContext, use } from 'react';

import { PageContainerContext } from './PageContainerContext.types';

export const PageContainerStateContext = createContext<PageContainerContext | undefined>(undefined);
PageContainerStateContext.displayName = 'PageContainerContext';

export function usePageContainerContext(): PageContainerContext {
    const context = use(PageContainerStateContext);
    if (context === undefined) {
        throw new Error('usePageContainerContext must be used within a PageContainerProvider');
    }

    return context;
}
